var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"circle"),React.createElement("circle",{"cx":"250","cy":"250","r":"250","style":{"fill":"#f5aa28"},"key":1})]);
}

Circle.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = Circle;

Circle.default = Circle;
